<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/brand/add-brand"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Brand</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" body-classes="px-0 pt-2 pb-1" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">
              <b-col sm="12" lg="4">
                <form>
                  <base-input type="search"
                              ref="search"
                              v-model="sq"
                              placeholder="Search Brands">
                  </base-input>
                </form>
              </b-col>
              <b-col sm="12" md="6" lg="4" class="d-flex align-items-left flex-wrap pt-2">
                <p class="mb-0 mr-2 text-sm">Show</p>

                <el-select class="select-primary pagination-select" v-model="perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>

                <p class="mb-0 ml-2 text-sm">recipes</p>

              </b-col>

              <b-col sm="12" md="6" lg="4" class="text-right">
                <a href="#" class="btn-view mr-1 active" @click="toggleActive($event, 'table')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="#32325d"><path d="M27 4H5C3.3 4 2 5.3 2 7v18c0 1.7 1.3 3 3 3h22c1.7 0 3-1.3 3-3V7c0-1.7-1.3-3-3-3zM13 20v-4h7v4h-7zm7 2v4h-7v-4h7zm0-12v4h-7v-4h7zm8 0v4h-6v-4h6zm-17 4H4v-4h7v4zm-7 2h7v4H4v-4zm18 0h6v4h-6v-4zM4 25v-3h7v4H5c-.6 0-1-.4-1-1zm23 1h-5v-4h6v3c0 .6-.4 1-1 1z"/></svg>
                </a>

                <a href="#" class="btn-view" @click="toggleActive($event, 'grid')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 50 50" fill="#32325d"><path d="M8.775 24.477h12.914a1 1 0 001-1V10.563a1 1 0 00-1-1H8.775a1 1 0 00-1 1v12.914a1 1 0 001 1zm1-12.914h10.914v10.914H9.775V11.563zM25.861 24.477h12.914a1 1 0 001-1V10.563a1 1 0 00-1-1H25.861a1 1 0 00-1 1v12.914a1 1 0 001 1zm1-12.914h10.914v10.914H26.861V11.563zM8.775 41.563h12.914a1 1 0 001-1V27.648a1 1 0 00-1-1H8.775a1 1 0 00-1 1v12.914a1 1 0 001 1.001zm1-12.915h10.914v10.914H9.775V28.648zM24.861 40.563a1 1 0 001 1h12.914a1 1 0 001-1V27.648a1 1 0 00-1-1H25.861a1 1 0 00-1 1v12.915zm2-11.915h10.914v10.914H26.861V28.648z"/></svg>
                </a>
              </b-col>
            </b-row>
          </template>
          <div>
            <div v-show="this.loading" class="loading">
              <loading-panel></loading-panel>
            </div>
            <el-table :data="brands"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results"
              v-if="view === 'table'">

              <el-table-column label="Result title" min-width="531px" prop="name" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <span v-if="row.brandId" style="padding-left:50px"></span>
                    <a :href="'/brand/' + row.id" class="avatar mr-3 table__avatar" :class="(!row.image)?'avatar--grey':' rounded-circle'">
                      <b-img alt="Image placeholder" :src="row.logo.absoluteUri" v-if="row.logo"></b-img>
                      <!--<span v-if="!row.image">{{ row.name ? row.name.charAt(0) : 'W' }}</span>-->
                    </a>
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/brand/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.name }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>
              <!--
              <el-table-column label="Status" min-width="175px" prop="status" sortable>
                <template v-slot="{ row }">
                  <badge class="badge-dot mr-4" type="inherit" v-if="row.statusCode">
                    <i :class="`bg-${row.statusCode}`"></i>
                    <span class="status font-weight-600">{{ row.statusName && row.statusName != null ? row.statusName : 'Created' }}</span>
                  </badge>
                </template>
              </el-table-column>
              -->

<!--
              <el-table-column label="Author" min-width="176px" prop="author" sortable>
                <template v-slot="{row}">
                  <b-img :src="row.user && row.user.image ? row.user.image.absoluteUri : 'img/DefaultUser.gif'" rounded="circle" class="avatar-sm mr-2"/>
                </template>
              </el-table-column>
-->

              <el-table-column label="Date created" min-width="201px" prop="date" sortable>
                <template v-slot="{ row }">
                  <span class="font-weight-600">{{ dateFormat(row.createdOn) }}</span>
                </template>
              </el-table-column>

              <el-table-column min-width="94px" align="last" label="Actions">
                <template v-slot="{ $index, row }" v-if="this.$store.getters.userIsAdmin">
                  <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light mr-0">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                      <b-dropdown-item @click.native="handleView($index, row)">View</b-dropdown-item>
                      <b-dropdown-item @click.native="handleEdit($index, row)">Edit</b-dropdown-item>
                      <b-dropdown-item @click.native="handleDelete($index, row)">Delete</b-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <!-- GRID -->
            <div class="cards" v-if="view === 'grid'">
              <div class="cards__item" v-for="row in brands" :key="row.index">
                <b-card no-body :img-src="row.logo ? row.logo.absoluteUri : 'img/ingredients/spinach_salad.jpg'" alt="Image placeholder" img-top>
                  <b-row class="justify-content-center">
                    <b-col lg="3"  class="order-lg-2">
                      <div class="card-profile-image">
                        <b-img :src="row.brand && row.brand.image !== null ? row.brand.image : 'img/whipstir/WhipStirLogo_blue.png'" rounded="circle" style="background-color: #fff;"/>
                      </div>
                    </b-col>
                  </b-row>
                  <b-card-header class="text-center border-0 pt-md-4 pb-0 pb-md-4">
                    <div class="d-flex justify-content-between align-items-center">
                      <badge class="badge-dot mr-4" type="inherit">
                        <i :class="`bg-${row.statusCode}`"></i>
                        <span class="status font-weight-600">{{ row.statusName ? row.statusName : 'Created' }}</span>
                      </badge>

                      <!-- <span class="text-sm font-weight-600">{{ row.format }}</span> -->
                    </div>
                  </b-card-header>
                  <b-card-body>
                    <b-card-title title-tag="h5" class="h2 mb-0">{{ row.name }}</b-card-title>
                    <small class="text-muted">{{ row.type }}</small><br />
                    <small class="text-muted">Created By {{ row.author && row.author.userName ? row.author.userName : 'WhipStir' }} on {{ dateFormat(row.recipeDate) }}</small>
                    <b-card-text class="mt-4">{{ row.description }}</b-card-text>
                    <a :href="row.id" @click="loadBrandPage($event)" class="btn btn-link px-0">View Brand</a>
                  </b-card-body>
                </b-card>
              </div><!-- /.cards__item -->
            </div><!-- /.cards -->
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ count }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="currentPage"
              :per-page="perPage"
              :total="count"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex'
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    LoadingPanel
  },
  mounted() {
      if(this.searchQuery != null && this.searchQuery != ''){
        this.sq = this.searchQuery;  
        var searchControl = this.$refs.search;
        var childTextBox = searchControl.$refs.textbox;
        childTextBox.focus();
      }
      this.searchBrands();
      const { dispatch } = this.$store;
      dispatch("users/getSelectList");
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchBrands();
    },
    sq: function (val,old) {
      this.sq = val;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.currentPage = 1;
            this.searchBrands();
            this.pauseSearch = false;
          }, 800); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  },
  props: [],
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      data: null,
      itemLimit: '10',
      view: 'table',
      currentBrandId: "",
      sq: this.$route.query.sq,
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      payload: {}
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.brands.loading
    },
    to() {
      let highBound = this.from + this.perPage;
      if (this.count < highBound) {
        highBound = this.count;
      }
      return highBound;
    },
    from() {
      return this.perPage * (this.currentPage - 1);
    },
    brands() {
      if (this.$store.state.brands.all) {
        return this.$store.state.brands.all[1]
      } else {
        return []
      }
      
    },
    count() {
      return this.$store.state.brands.all[0];
    },
    users() {
      return this.$store.state.users.selectList
    }
  },
  methods: {
    dateFormat(date) {
      if (date) {
        var local = new Date(date);
        return local.toLocaleDateString("en-US")
      } else {
        return 'No Date'
      }
    },
    paginationChanged(page) {
      this.currentPage = page;
      this.searchBrands();
    },
    handleView(index, row) {
      this.$router.push(`/brand/${row.id}`)
    },
    handleEdit(index, row) {
      this.$router.push(`/brand/edit-brand/${row.id}`)
    },
    handleDelete(index, row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          
          const { dispatch } = this.$store;
          dispatch("brands/deleteBrand", row.id).then(response => {
            this.deleteRow(row);
            return response;
          })
          .catch(error => {
            return error;
          });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.brands.findIndex((tableRow) => tableRow.id === row.id);
      if (indexToDelete >= 0) {
        this.brands.splice(indexToDelete, 1);
      }
    },
    toggleActive(event, view) {
      event.preventDefault();

      const button = event.target.closest('.btn-view');
      const card = document.querySelector('.card-results');

      button.classList.add('active')

      Array.prototype.filter.call(button.parentNode.children, function(child){
        if (child !== button) {
          child.classList.remove('active')
        }
      });

      this.view = view;

      this.view == 'grid'
        ? card.classList.add('card-results--alt')
        : card.classList.remove('card-results--alt')
    },
    searchBrands() {
      const { dispatch } = this.$store;

      this.payload.query = this.sq;
      this.payload.page = this.currentPage;
      this.payload.pageSize = this.perPage;
      dispatch("brands/getAllBrands",this.payload);
    }
  },
  created() {
    const { dispatch } = this.$store;
    this.payload.query = this.sq;
    this.payload.page = this.currentPage;
    this.payload.pageSize = this.perPage;
    dispatch("brands/getAllBrands",this.payload);
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
